import { CaixaProps } from "../../components/Estrutura/Caixa";

export const microfones: CaixaProps[] = [
  {
    nome: "Sennheiser e835 (1)",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  },
  {
    nome: "Sennheiser e835 (2)",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  },
  {
    nome: "Shure SM58 (1)",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  },
  {
    nome: "Shure SM58 (2)",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  },
  {
    nome: "CSR HT-58A",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  },
  {
    nome: "Shure SV200 (1)",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  },
  {
    nome: "Shure SV200 (2)",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  },
  {
    nome: "Dylan DLS-8",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  },
  {
    nome: "AKG P3s",
    descricao: "Microfone dinâmico cardioide",
    img: "",
  }
];